(function() {
    var SUNDAY_MESSAGE = 'Sorry, Sunday delivery is not available. We are closed on Sundays — please choose another date.';

    function pad(n) { return String(n).padStart(2, '0'); }

    function toISODate(date) {
        return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
    }

    function parseISODate(str) {
        if (!str) return null;
        var parts = str.split('-');
        if (parts.length !== 3) return null;
        var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
        if (isNaN(d.getTime())) return null;
        return d;
    }

    function isSunday(date) { return date.getDay() === 0; }

    function createDatePicker(input) {
        if (input.dataset.datepickerInit) return;
        input.dataset.datepickerInit = 'true';

        input.setAttribute('readonly', 'readonly');
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('inputmode', 'none');

        var wrapper = document.createElement('div');
        wrapper.className = 'delivery-datepicker-wrapper';
        input.parentNode.insertBefore(wrapper, input);
        wrapper.appendChild(input);

        var icon = document.createElement('span');
        icon.className = 'delivery-datepicker-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '📅';
        wrapper.appendChild(icon);

        var popup = document.createElement('div');
        popup.className = 'delivery-datepicker-popup';
        popup.setAttribute('role', 'dialog');
        popup.setAttribute('aria-label', 'Choose delivery date');
        wrapper.appendChild(popup);

        var today = new Date();
        today.setHours(0, 0, 0, 0);

        var viewDate = parseISODate(input.value) || new Date(today);
        viewDate.setDate(1);

        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        var sundayMessageTimeout = null;

        function isPast(date) { return date < today; }

        function render() {
            var selected = parseISODate(input.value);
            var firstOfMonth = new Date(viewDate.getFullYear(), viewDate.getMonth(), 1);
            var startDay = firstOfMonth.getDay();
            var daysInMonth = new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 0).getDate();
            var isAtOrBeforeCurrentMonth = (viewDate.getFullYear() < today.getFullYear()) ||
                (viewDate.getFullYear() === today.getFullYear() && viewDate.getMonth() <= today.getMonth());

            var html = '';
            html += '<div class="delivery-datepicker-message" data-role="message"></div>';
            html += '<div class="delivery-datepicker-header">';
            html += '<button type="button" class="delivery-datepicker-nav prev"' + (isAtOrBeforeCurrentMonth ? ' disabled' : '') + ' aria-label="Previous month">&#8249;</button>';
            html += '<span class="delivery-datepicker-month-label">' + monthNames[viewDate.getMonth()] + ' ' + viewDate.getFullYear() + '</span>';
            html += '<button type="button" class="delivery-datepicker-nav next" aria-label="Next month">&#8250;</button>';
            html += '</div>';

            html += '<div class="delivery-datepicker-weekdays">';
            ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].forEach(function(d) {
                html += '<span class="delivery-datepicker-weekday' + (d === 'Su' ? ' is-sunday' : '') + '">' + d + '</span>';
            });
            html += '</div>';

            html += '<div class="delivery-datepicker-grid">';
            for (var i = 0; i < startDay; i++) {
                html += '<span class="delivery-datepicker-day is-outside"></span>';
            }
            for (var day = 1; day <= daysInMonth; day++) {
                var date = new Date(viewDate.getFullYear(), viewDate.getMonth(), day);
                var classes = ['delivery-datepicker-day'];
                var disabled = false;

                if (isPast(date)) {
                    classes.push('is-disabled');
                    disabled = true;
                } else if (isSunday(date)) {
                    classes.push('is-sunday');
                }
                if (selected && toISODate(selected) === toISODate(date)) classes.push('is-selected');
                if (toISODate(date) === toISODate(today)) classes.push('is-today');

                html += '<button type="button" class="' + classes.join(' ') + '" data-date="' + toISODate(date) + '"' + (disabled ? ' disabled' : '') + '>' + day + '</button>';
            }
            html += '</div>';

            html += '<div class="delivery-datepicker-legend"><span class="legend-swatch"></span> Closed Sundays</div>';

            popup.innerHTML = html;

            popup.querySelector('.prev').addEventListener('click', function() {
                if (this.disabled) return;
                viewDate.setMonth(viewDate.getMonth() - 1);
                render();
            });
            popup.querySelector('.next').addEventListener('click', function() {
                viewDate.setMonth(viewDate.getMonth() + 1);
                render();
            });

            popup.querySelectorAll('.delivery-datepicker-day[data-date]').forEach(function(btn) {
                btn.addEventListener('click', function() {
                    var dateStr = this.getAttribute('data-date');
                    var date = parseISODate(dateStr);
                    if (!date || isPast(date)) return;

                    if (isSunday(date)) {
                        showSundayMessage();
                        return;
                    }

                    input.value = dateStr;
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                    closePopup();
                });
            });
        }

        function showSundayMessage() {
            var msgEl = popup.querySelector('[data-role="message"]');
            if (!msgEl) return;
            msgEl.textContent = SUNDAY_MESSAGE;
            msgEl.classList.add('is-visible');
            if (sundayMessageTimeout) clearTimeout(sundayMessageTimeout);
            sundayMessageTimeout = setTimeout(function() {
                msgEl.classList.remove('is-visible');
            }, 4000);
        }

        function openPopup() {
            var selected = parseISODate(input.value);
            viewDate = selected ? new Date(selected) : new Date(today);
            viewDate.setDate(1);
            render();
            popup.classList.add('is-open');
            document.addEventListener('click', handleOutsideClick);
        }

        function closePopup() {
            popup.classList.remove('is-open');
            document.removeEventListener('click', handleOutsideClick);
        }

        function handleOutsideClick(e) {
            if (!wrapper.contains(e.target)) closePopup();
        }

        function togglePopup(e) {
            e.stopPropagation();
            if (popup.classList.contains('is-open')) {
                closePopup();
            } else {
                openPopup();
            }
        }

        input.addEventListener('click', togglePopup);
        icon.addEventListener('click', togglePopup);

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') closePopup();
        });
    }

    function init() {
        document.querySelectorAll('[data-delivery-datepicker]').forEach(createDatePicker);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
